module.exports = __webpack_public_path__ + "static/media/pr.d37180b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/pr.png
// module id = 1960
// module chunks = 0